import {
  BankOutlined,
  CheckCircleFilled,
  ExclamationCircleOutlined,
  TeamOutlined,
} from '@ant-design/icons';
import { useTranslation } from 'react-i18next';

import s from './styles.module.scss';

import type { FC } from 'react';

const MA_SUGGESTED = 4;
const RN_SUGGESTED = 1;

interface IPodSummaryPanelProps {
  clinicsSelected: number;
  patients: number;
  maAssigned: number;
  rnAssigned: number;
}

const PodSummaryPanel: FC<IPodSummaryPanelProps> = ({
  clinicsSelected,
  patients,
  maAssigned,
  rnAssigned,
}) => {
  const { t } = useTranslation();

  return (
    <div className={s.panel} data-cy="pod-summary-panel">
      <div className={s.capacitySection}>
        <div className={s.sectionTitle}>{t('labels.panelCapacity')}</div>
        <div className={s.capacityItem}>
          <div className={s.capacityIcon}>
            <BankOutlined />
          </div>
          <div className={s.capacityInfo}>
            <span className={s.capacityLabel}>
              {t('labels.clinicsSelected')}
            </span>
            <span
              className={s.capacityValue}
              role="status"
              aria-live="polite"
              data-cy="clinics-selected-value"
            >
              {clinicsSelected}
            </span>
          </div>
        </div>
        <div className={s.capacityItem}>
          <div className={s.capacityIcon}>
            <TeamOutlined />
          </div>
          <div className={s.capacityInfo}>
            <span className={s.capacityLabel}>{t('labels.patients')}</span>
            <span
              className={s.capacityValue}
              role="status"
              aria-live="polite"
              data-cy="patients-value"
            >
              {patients}
            </span>
          </div>
        </div>
      </div>
      <div className={s.staffingSection}>
        <div className={s.sectionTitle}>{t('labels.suggestedStaffing')}</div>
        <div className={s.staffingRow}>
          <span className={s.staffingLabel}>MA</span>
          <div className={s.staffingStatus}>
            <span data-cy="ma-staffing-value">
              {maAssigned} / {MA_SUGGESTED}
            </span>
            {maAssigned >= MA_SUGGESTED ? (
              <CheckCircleFilled
                className={s['staffing-icon-success']}
                data-cy="ma-staffing-icon-success"
              />
            ) : (
              <ExclamationCircleOutlined
                className={s.staffingIcon}
                data-cy="ma-staffing-icon-warning"
              />
            )}
          </div>
        </div>
        <div className={s.staffingRow}>
          <span className={s.staffingLabel}>RN</span>
          <div className={s.staffingStatus}>
            <span data-cy="rn-staffing-value">
              {rnAssigned} / {RN_SUGGESTED}
            </span>
            {rnAssigned >= RN_SUGGESTED ? (
              <CheckCircleFilled
                className={s['staffing-icon-success']}
                data-cy="rn-staffing-icon-success"
              />
            ) : (
              <ExclamationCircleOutlined
                className={s.staffingIcon}
                data-cy="rn-staffing-icon-warning"
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PodSummaryPanel;
